// extracted by mini-css-extract-plugin
export default {"container":"dk-z","heading":"ek-z","items":"fk-z","action":"gk-z","disabled":"hk-z"};